export default "__VITE_PUBLIC_ASSET__b830d460__"